module.exports = __webpack_public_path__ + "media/paliwa/other@2x-b1aadbb5.png";